import { Core as WalletConnectCore } from "./core.js";

export * from "./constants/index.js";
export * from "./controllers/index.js";

export const Core = WalletConnectCore;
export default WalletConnectCore;
